<template>
  <div class="content">
    <div class="header">
      <van-nav-bar title="确认订单" left-arrow @click-left="toback" />
    </div>
    <div v-if="this.AddressShow" @click="toAddress" class="address">
      <div class="mobile">
        <span class="nameLeft">{{ this.AddressList[0].consignee }}</span>
        <span class="mobileRight">{{ this.mobile }} </span>
        <van-icon name="arrow" />
      </div>
      <p>{{ this.AddressList[0].address_str }}</p>
    </div>
    <div v-else @click="toAddress" class="address">
      <div class="mobiles">
        <span class="nameLeft">请添加收货地址</span>
        <van-icon class="right" name="arrow" />
      </div>
      <!-- <p class="addressInfo"></p> -->
    </div>
    <div class="product">
      <van-card
        v-for="(item, index) in productList"
        :key="index"
        :num="item.goods_num"
        :price="Number(item.price).toFixed(2)"
        :desc="item.color_name"
        :title="item.product_name"
        :thumb="item.color_img"
      >
      </van-card>
      <div slot="footer">
        <van-cell title="配送方式" value="快递配送" />
        <van-field
          v-model="messages"
          rows="2"
          autosize
          label="买家留言"
          type="textarea"
          maxlength="45"
          placeholder="建议留言前与商家沟通确认"
          show-word-limit
        />
      </div>
    </div>
    <div class="productMoney">
      <van-cell
        title="商品金额"
        class="money"
        :value="'￥' + Number(money).toFixed(2)"
      />
      <van-cell title="运费" value="￥0" />
      <van-cell title="优惠券" value="暂无可用" />
    </div>
    <div class="preferential">
      <van-cell title="支付方式" value="在线支付" />
      <van-cell @click="show = true" is-link title="发票" :value="invoice">
      </van-cell>
    </div>
    <div class="submitBar">
      <van-submit-bar
        :decimal-length="0"
        button-text="去支付"
        @submit="toPayMoney"
      >
        <template #default>
          <div class="submitBarTitle">
            <p>
              合计:<span>¥{{ Number(money).toFixed(2) }}</span
              ><span class="freeShipping">免运费</span>
            </p>
          </div>
        </template>
      </van-submit-bar>
    </div>
    <van-action-sheet v-model="show">
      <div class="invoice" style="">
        <!-- title -->
        <div class="title">
          <p
            style="padding-left:0.4267rem;color:#000000;font-weight: 600; fonst-size:0.48rem"
          >
            填写发票信息
          </p>
          <div class="title-right" style="padding-right:0.4267rem">
            <p>
              <span @click="getNotice">发票须知</span
              ><van-icon style="vertical-align: -18%" name="info-o" />
            </p>
            <van-icon @click="show = false" name="cross" />
          </div>
        </div>
        <!-- content -->
        <div>
          <keep-alive>
            <Invoice :money="money" @chengeSubmit="AmountChange"></Invoice>
          </keep-alive>
        </div>
      </div>
    </van-action-sheet>
    <!-- 发票须知弹窗  -->
    <van-dialog
      v-model="invoiceShow"
      title="发票须知"
      :showConfirmButton="false"
      round-button
      class="invoice-foot"
    >
      <div
        style="color:#000000;font-size:0.32rem;padding: 0 0.4533rem 0  0.72rem;line-height: 0.5067rem;"
      >
        <p>
          1.依照税局最新开票法规，发票开具内容均为明细。
        </p>
        <p>
          2.开票金额为用户实际支付的金额（不含礼品卡与不支持该发票类型的商品实付金额）。
        </p>
        <p>
          3.单笔订单只支持开具一种类型的发票。
        </p>
        <p>
          4.选择开具增值税专用发票时，请确保专票资质信息与贵司税务登记证的信息一致，以免因开票给贵司带来损失。
        </p>
      </div>
      <p style="text-align:center;">
        <van-button
          style="padding:0 1.4rem;height:1rem"
          @click="invoiceShow = false"
          round
          color="#FC563A"
          >确认</van-button
        >
      </p>
    </van-dialog>
  </div>
</template>
<script>
import Invoice from "../../components/invoice/invoice.vue";
export default {
  components: {
    Invoice,
  },
  data() {
    return {
      messages: "",
      show: false,
      invoiceShow: false,
      AddressList: {},
      AddressShow: false,
      money: 0,
      productList: JSON.parse(sessionStorage.getItem("PRODUCT_LIST")),
      addressId: sessionStorage.getItem("_ADDRESS"),
      mobile: "",
      toPay: false,
      invoice: "不开发票",
      invoiceId: "",
    };
  },
  mounted() {
    this.getAddressList();
    this.sessValue();
    this.moneys();
  },
  methods: {
    moneys() {
      this.productList.forEach((item) => {
        if (item.onsell_num > 0) {
          this.toPay = true;
        } else {
          this.toPay = false;
        }
        if (item.goods_num === undefined || item.goods_num < 1) {
          item.goods_num = 1;
        }
        this.money += Number(item.price * item.goods_num);
      });
      sessionStorage.setItem("moneys", this.money);
    },
    async toPayMoney() {
      try {
        // 判断是否选择地址
        if (this.AddressShow) {
          // 如果是购物车过来的
          if (this.productList[0].hasOwnProperty("record_id")) {
            let chosens = this.productList.map((item) => {
              return item.record_id;
            });
            let data =
              "money=" +
              this.money.toFixed(2) +
              "&num=" +
              "&recordIds=" +
              chosens.toString() +
              "&yuqidata";
            const res = await this.$post({
              url: "/oor/saveOmsOrderRecord",
              method: "post",
              params: {
                addressId: this.AddressList[0].address_id, //下单地址
                money: this.money.toFixed(2), //金钱
                recordIds: chosens.toString(), //购物车id
                userId: sessionStorage.getItem("EXCLUSIVE"),
                remark: this.messages, //备注
                invoiceId: this.invoiceId, //发票
                signature: this.$md5(data), //
              },
            });
            if (res.retCode === 200) {
              sessionStorage.removeItem("R_N");
              sessionStorage.removeItem("V_N");
              sessionStorage.setItem("PRODUCT_NUMBER", res.data.recordCode);
              sessionStorage.setItem("NUM_BER", res.data.prepay_id);
              this.$router.push({
                path: "/payment",
                query: {
                  m: this.money,
                },
              });
              sessionStorage.removeItem("L_Y");
              if (this.$route.path == "/payment") {
                this.$router.go(0);
              } else {
                return false;
              }
            } else {
              this.$toast(res.message);
              return false;
            }
          } else {
            // 立即购买过来的
            let chosens = this.productList.map((item) => {
              return item.recordId;
            });
            let data =
              "money=" +
              this.money.toFixed(2) +
              "&num=" +
              sessionStorage.getItem("PRODUCT_NUM") +
              "&productCode=" +
              chosens.toString() +
              "&yuqidata";
            const res = await this.$post({
              url: "/oor/saveOmsOrderRecord",
              method: "post",
              params: {
                addressId: this.AddressList[0].address_id, //下单时地址id
                money: this.money.toFixed(2), // 下单总计
                recordIds: "", //购物车id
                goodsId: this.$route.query.goodsId, // 商品id
                skuId: this.$route.query.skuId, // sku id
                productCode: chosens.toString(), //
                userId: sessionStorage.getItem("EXCLUSIVE"),

                remark: this.messages, // 备注
                num: sessionStorage.getItem("PRODUCT_NUM"), // 下单数量
                signature: this.$md5(data), //
                invoiceId: this.invoiceId, // 发票id
              },
            });
            if (res.retCode === 200) {
              sessionStorage.removeItem("R_N");
              sessionStorage.removeItem("V_N");
              sessionStorage.setItem("PRODUCT_NUMBER", res.data.recordCode);
              sessionStorage.setItem("NUM_BER", res.data.prepay_id);
              this.$router.push({
                path: "/payment",
                query: {
                  m: this.money,
                },
              });
              sessionStorage.removeItem("L_Y");
              if (this.$route.path == "/payment") {
                this.$router.go(0);
              } else {
                // this.$toast(res.message);
                return false;
              }
            } else {
              this.$toast(res.message);
              return false;
            }
          }
        } else {
          this.$toast("请选择地址");
        }
      } catch (err) {
        this.$toast("提交失败");
        return false;
      }
    },
    // 获取地址信息
    async getAddressList() {
      if (this.addressId == null) {
        if (sessionStorage.getItem("AREA").indexOf("/") == -1) {
          return false;
        } else {
          this.$dialog
            .confirm({
              title: "温馨提示",
              message:
                "您在浏览商品过程中选择了新的地址，是否将它设定为收货地址？",
            })
            .then(() => {
              this.$router.push("/addToAddress");
            })
            .catch(() => {
              // sessionStorage.removeItem("AREA");
            });
        }
        await this.$post({
          url: "/omsConsigneeAddress/findAll",
          method: "post",
          params: {
            userId: sessionStorage.getItem("EXCLUSIVE"),
          },
        })
          .then((res) => {
            if (res.retCode == 200) {
              if (Object.keys(this.AddressList).length !== 0) {
                this.AddressShow = true;
              } else {
                this.AddressShow = false;
                this.AddressList = res.data.code;
                this.mobile = this.AddressList[0].mobile.replace(
                  this.AddressList[0].mobile.substr(3, 4),
                  "****"
                );
              }
            }
          })
          .catch((err) => {
            console.log(err);
            // return;
          });
      } else {
        await this.$post({
          url: "/omsConsigneeAddress/findAll",
          method: "post",
          params: {
            userId: sessionStorage.getItem("EXCLUSIVE"),
          },
        }).then((res) => {
          if (res.retCode == 200) {
            this.AddressShow = true;
            this.AddressList = res.data.code.filter((item) => {
              return this.addressId == item.address_id;
            });
            this.mobile = this.AddressList[0].mobile.replace(
              this.AddressList[0].mobile.substr(3, 4),
              "****"
            );
            if (sessionStorage.getItem("AREA").indexOf("/") == -1) {
              return false;
            } else {
              this.$dialog
                .confirm({
                  title: "温馨提示",
                  message:
                    "您在浏览商品过程中选择了新的地址，是否将它设定为收货地址？",
                })
                .then(() => {
                  this.$router.push("/addToAddress");
                })
                .catch(() => {
                  // sessionStorage.removeItem("AREA");
                });
            }
          }
        });
      }
    },
    toAddress() {
      sessionStorage.setItem("L_Y", this.messages);
      this.$router.push("/orderAddress");
    },
    sessValue() {
      if (this.value == "" && sessionStorage.getItem("L_Y") == undefined) {
        return false;
      } else {
        this.messages = sessionStorage.getItem("L_Y");
      }
    },
    toback() {
      this.$router.back();
      sessionStorage.removeItem("L_Y");
    },
    // 发票须知
    getNotice() {
      this.invoiceShow = true;
    },
    AmountChange(isShow, genre, username, invoiceId) {
      this.show = isShow;
      this.invoiceId = invoiceId;
      if (genre == "1"||genre=='2') {
        this.invoice = "纸质普通发票（明细——" + username + "）";
      } else {
        this.invoice = "增值税专用发票（明细——" + username + "）";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  padding-top: 1.4rem;
  padding-bottom: 1.2rem;
  width: 100%;
  position: relative;
  background-color: #fafafa;
  .header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    background-color: #fff;
    /deep/.van-nav-bar {
      background-color: #40000000;
      .van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      .van-nav-bar__left {
        .van-icon.van-icon-arrow-left.van-nav-bar__arrow {
          margin-top: 0.1rem;
          color: #030303 !important;
          font-size: 0.533333rem;
        }
      }
    }
    /deep/.van-nav-bar__title {
      font-weight: 600 !important;
    }
  }
  .address {
    position: relative;
    width: 9.2rem;
    margin: 0 auto;
    background-color: #fff;
    .mobiles {
      padding: 0.346667rem 0.346667rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .right {
        // margin-top: 0.0.55rem;
        display: block;
      }
    }
    .mobile {
      display: flex;
      align-items: center;
      padding: 0.27rem 0.27rem 0 0.27rem;
      // overflow: hidden;
      // font-size: 0.4rem;
      .nameLeft {
        float: left;
        width: 4.878rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .mobileRight {
        line-height: 0.64rem;
        margin-left: 0.29rem;
        position: relative;
        float: left;
        text-align: center;
        vertical-align: middle;
        color: #333;
        overflow: hidden;
      }
      .van-icon {
        color: #666666;
        position: absolute;
        top: 0.8rem;
        left: 8.4rem;
        font-size: 0.5rem;
        vertical-align: middle;
      }
    }
    p {
      width: 7.5rem;
      color: #999999;
      padding: 0.266667rem 0.27rem 0.27rem 0.27rem;
      font-size: 0.4rem;
    }
    .addressInfo {
      padding: 0.3rem 0.27rem;
    }
  }
  .payFashion {
    margin-top: 0.11rem;
    background-color: #fff;
    .van-radio-group {
      .van-cell-group {
        .van-cell.van-cell--clickable {
          position: static;
          border-bottom: none;
          img {
            width: 0.61rem;
            height: 0.61rem;
            margin-right: 0.27rem;
          }
        }
      }
    }
  }
  .product {
    width: 9.2rem;
    margin: 0 auto;
    margin-top: 0.27rem;
    padding: 0.27rem 0;
    background-color: #fff;
    .van-card {
      background-color: #fff;
      padding: 0;
      .van-card__header {
        .van-card__content {
          margin-left: 1.2rem;
          .van-card__title {
            margin-top: 0.3rem;
          }
          .van-card__bottom {
            .van-card__price {
              color: red;
            }
            .van-card__num {
              margin-right: 0.35rem;
            }
          }
        }
        .van-card__thumb {
          /deep/img {
            margin-left: 0.4rem;
            display: block;
            // width: 2.88rem;
            // height: 2.24rem;
          }
        }
      }
      .van-card__footer {
        margin-top: 0.45rem;
        .van-cell {
          padding: 0;
          /deep/.van-field__label {
            width: 1.8rem;
            text-align-last: left;
          }
        }
      }
    }
    .van-cell__value {
      color: #333 !important;
    }
  }
  .preferential {
    width: 9.2rem;
    margin: 0 auto;
    margin-top: 0.27rem;
    background-color: #fff;
    .van-cell__value {
      color: #333 !important;
    }

    .van-cell.van-cell--clickable.van-coupon-cell {
      position: static;
    }
    /deep/.van-cell__value {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .productMoney {
    width: 9.2rem;
    margin: 0 auto;
    margin-top: 0.27rem;
    background-color: #fff;
    .van-cell {
      .van-cell__value {
        color: #333 !important;
      }
    }
    .money {
      .van-cell__value {
        color: #f74b2e !important;
      }
    }
    .fare {
      .van-swipe-cell__wrapper {
        .van-cell {
          .van-cell__value {
            color: red;
          }
        }
      }
    }
  }
  .van-submit-bar {
    .van-submit-bar__bar {
      /deep/.submitBarTitle {
        width: 8rem;
        p {
          font-size: 0.37rem;
          width: 100%;
          span {
            color: #f74b2e;
          }
        }
        .freeShipping {
          margin-left: 0.32rem;
          font-size: 0.27rem;
          color: #333;
        }
      }
    }
    .van-button {
      width: 1.87rem;
      height: 0.72rem;
      line-height: 0.72rem;
      background-color: #f74b2e;
      border-color: #f74b2e;
      padding: 0;
    }
  }
  .invoice {
    padding: 0.4533rem 0;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .title-right {
      display: flex;
      align-items: center;
      p {
        display: flex;
        margin-right: 0.2667rem;
        display: block;
        color: #999999;
        font-size: 0.3733rem;
      }
    }
  }
  /deep/.van-dialog {
    height: auto;
    border-radius: 0.5067rem;
  }
  /deep/.van-card__desc {
    margin-top: 0.2667rem;
    font-size: 0.2667rem;
    color: #999999;
  }
  .invoice-foot {
    /deep/.van-button--normal {
      margin: 0.3733rem 0;
      // padding: 0rem 1.2rem;
    }

    /deep/.van-dialog__content {
      margin-top: 0.32rem;
    }
    /deep/.van-dialog__header {
      color: #000000;
      font-size: 0.4533rem;
      font-weight: 600;
    }
  }
}
</style>
